// borrowed a lot from https://gist.github.com/aaerofeev/c792fa73a18c743b7dd861368c886880

declare var $: any;
const em_list = [0.8, 1, 1.5, 2, 3];
import { reduce } from 'lodash-es';

if (typeof $ !== 'undefined' && typeof $.FroalaEditor !== 'undefined') {
  $.FroalaEditor.DEFAULTS = $.extend($.FroalaEditor.DEFAULTS, {
    inlineClasses: {
      ...$.FroalaEditor.DEFAULTS.inlineClasses,
      ...reduce(
        em_list,
        (acc, em, index) => {
          return {
            ...acc,
            [`x${parseFloat('' + em).toFixed(1)}`]: `font-${em * 100}-percent`
          };
        },
        {}
      )
    }
  });
  $.FroalaEditor.DefineIcon('custom_fontsize_dropdown', { NAME: 'cog' });
  $.FroalaEditor.RegisterCommand('custom_fontsize_dropdown', {
    title: '글씨크기',
    type: 'dropdown',
    focus: true,
    undo: false,
    displaySelection: true,
    defaultSelection: 'x1.0',
    displaySelectionWidth: 40,
    refreshAfterCallback: true,
    options: reduce(
      em_list,
      (acc, em, index) => {
        return {
          ...acc,
          [`font-${em * 100}-percent`]: `x${parseFloat('' + em).toFixed(1)}`
        };
      },
      {}
    ),
    callback: function(cmd, val) {
      const cls = $(this.selection.element()).attr('class');
      const isFormatted = this.format.is('span', { class: cls });

      if (!cls) {
        this.inlineClass.apply(val);
        this.format.applyStyle(
          'font-size',
          parseInt(val.replace(/\D/g, '')) / 100 + 'rem'
        );
        return;
      }

      if (isFormatted) {
        em_list.forEach(em => {
          this.format.remove('span', { class: `font-${em * 100}-percent` });
          this.format.removeStyle('font-size');
        });
      }

      this.inlineClass.apply(val);
      this.format.applyStyle(
        'font-size',
        parseInt(val.replace(/\D/g, '')) / 100 + 'rem'
      );

      // if (cls !== val) {
      // hot fix to count the canceling of the class
      // that happens when the same class is used as the one used before in the same line.
      // if ($(this.selection.element()).attr('class') !== val) {
      // elem.attr('class', val);
      // this.inlineClass.apply(val);
      // }
      // }
    },
    // Callback on refresh.
    refresh: function($btn) {
      const cls = $(this.selection.element()).attr('class');
      let rem: string;
      if (cls && cls.match(/font\-([\d]+)\-percent/)) {
        rem = `x${(
          Number(cls.match(/font\-([\d]+)\-percent/)[1]) / 100
        ).toFixed(1)}`;
      } else {
        rem = 'x1.0';
      }
      $btn.find('> span').text(rem);
    },
    // Callback on dropdown show.
    refreshOnShow: function($btn, $dropdown) {
      // active item handling
      let cls = $(this.selection.element()).attr('class');
      if (!cls || !cls.match(/font\-([\d]+)\-percent/)) {
        cls = `font-100-percent`;
      }
      $dropdown
        .find('.fr-command.fr-active')
        .removeClass('fr-active')
        .attr('aria-selected', !1),
        $dropdown
          .find('.fr-command[data-param1="' + cls + '"]')
          .addClass('fr-active')
          .attr('aria-selected', !0);

      // scroll handling
      var f = $dropdown.find('.fr-dropdown-list'),
        g = $dropdown.find('.fr-active').parent();
      g.length
        ? f
            .parent()
            .scrollTop(
              g.offset().top -
                f.offset().top -
                (f.parent().outerHeight() / 2 - g.outerHeight() / 2)
            )
        : f.parent().scrollTop(0);
    }
  });
}
